import { observer } from 'mobx-react-lite';
import { Box, FormCardSection, MaskedInput, Select } from '/src/components';
import { ReferralPartner } from '/src/lib/models/ReferralPartner';
import { FormErrors, ReferralCommissionDataForm } from '/src/lib/types';

export type ReferralCommissionsProps = {
  id?: string;
  commissions: ReferralCommissionDataForm[];
  setCommissions: (values: ReferralCommissionDataForm[]) => void;
  formErrors: Record<string, FormErrors>;
  referralPartners: ReferralPartner[];
};

export const ReferralCommissions: React.FC<ReferralCommissionsProps> = observer((props) => {
  const { id, commissions, setCommissions, formErrors } = props;

  /** Methods **/
  const updateFormValue = (key: keyof ReferralCommissionDataForm, index: number, value: unknown) => {
    const updatedValues = [...commissions];
    updatedValues[index] = {
      ...updatedValues[index],
      [key]: value,
    };
    setCommissions(updatedValues);
    formErrors[index] ??= {} as FormErrors;
    if (formErrors[index][key]) formErrors[index][key] = '';
  };

  /** Render **/
  return (
    <FormCardSection id={id} title="Referral Commissions">
      {commissions.map((commission, index) => (
        <Box row gap="1rem" key={index}>
          <Select
            id="referral_partner_id"
            label="Referrer"
            value={commission.referral_partner_id}
            setValue={(value) => updateFormValue('referral_partner_id', index, value)}
            options={
              props.referralPartners?.map((partner: ReferralPartner) => ({ label: partner.name, value: partner.id })) ||
              []
            }
            error={formErrors[index]?.['referral_partner_id']}
            fill="horizontal"
          />
          <MaskedInput
            id="referral_commission_percent_rate"
            label="Commission Percent (%)"
            value={commission.percent_rate}
            setValue={(value) => updateFormValue('percent_rate', index, value)}
            error={formErrors[index]?.['percent_rate']}
            componentType="percent"
            isActiveLabel
            fill="horizontal"
          />
        </Box>
      ))}
    </FormCardSection>
  );
});
